import React, { useEffect, useState } from "react";
import "./MoneyReceivedPdf.scss";
import { useParams } from "react-router-dom";

const MoneyReceivedPdf = () => {
  const rupali_api_url = process.env.REACT_APP_RUPALI_API_HOST;

  const { id } = useParams();

  const [status, setStatus] = useState("loading");

  useEffect(() => {
    if (id) {
      const encodedMrId = id;
      const pdfDownloadUrl = `${rupali_api_url}/Api/WebSite/DownloadReceipt?MrId=${encodedMrId}`;

      // Create hidden anchor for download
      const link = document.createElement("a");
      link.href = pdfDownloadUrl;
      link.setAttribute("download", `Receipt-${encodedMrId}.pdf`);
      document.body.appendChild(link);

      // Delay for showing loader
      setTimeout(() => {
        link.click();
        document.body.removeChild(link);
        setStatus("success");
      }, 700);
    }
  }, [id]);

  return (
    <>
      <div className="container">
        <div
          className="money_receipt_container"
          style={{ textAlign: "center", margin: "50px 0" }}
        >
          {status === "loading" && (
            <div className="money_receipt_content">
              <div>
                <h2>Downloading your receipt...</h2>
                <p>Please wait while we download your file.</p>
                <div className="loader" />
              </div>
            </div>
          )}
          {status === "success" && (
            <div className="money_receipt_content">
              <div>
                <h2>✅ Download Complete!</h2>
                <p>Your receipt has been downloaded.</p>
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default MoneyReceivedPdf;
